import { babyface } from '../CDNUrl';

const HOME_BANNER_URI = `${babyface}/home/home_banner`;

export const HOME_BANNER_GC_CARE = {
  src: `${HOME_BANNER_URI}_gc_care.png`,
  alt: `현대해상 굿앤굿 어린이보험 상담 신청 이벤트 홈배너`,
};